<form class="example-form">
  <mat-form-field class="example-full-width">
    <mat-label>Id</mat-label>
    <input matInput (input)="handleIdChange($event.target.value)" placeholder="Component Id" [value]="id">
  </mat-form-field>

  <mat-form-field class="example-full-width">
    <mat-label>Name</mat-label>
    <input matInput (input)="handleNameChange($event.target.value)" placeholder="Component Name" [value]="label">
  </mat-form-field>
</form>